import { Image, Menu, Button, Layout } from 'antd';
import { CodeSandboxOutlined, DiffOutlined, FilePdfOutlined, FolderOpenOutlined, FundProjectionScreenOutlined, LogoutOutlined, TrophyOutlined, UserOutlined } from '@ant-design/icons';

import { useAuth } from "../context/AuthEgresadosProvider";
import CvGenerator from "../pages/Alumnos/CvGenerator/CvGenerator";
import ConalepLogo from './../../../assets/images/escudos/conalepEDOMEX.png';
import { useEgresadoContext } from '../context/EgresadoProvident';

const { Header } = Layout;

const HeaderEgresados = () => {
    const { logout } = useAuth();
    const { showWelcomeCard, setShowWelcomeCard } = useEgresadoContext();

    const onValidateShowWelcome = () => {
        if (showWelcomeCard) { 
            setShowWelcomeCard((prev) => !prev);
        }
    };

    const dropdownItems = [
        { key: 'key-1', label: <a href="#Inicio">Perfil</a>, icon: <UserOutlined /> },
        { key: 'key-2', label: <a href="#Habilidades">Habilidades</a>, icon: <TrophyOutlined /> },
        { key: 'key-3', label: <a href="#Software">Software</a>, icon: <CodeSandboxOutlined /> },
        { key: 'key-4', label: <a href="#Idiomas">Idiomas</a>, icon: <FolderOpenOutlined /> },
        { key: 'key-5', label: <a href="#ExperienciaAcademica">Experiencia Académica</a>, icon: <FundProjectionScreenOutlined /> },
        { key: 'key-6', label: <a href="#ExperienciaLaboral">Experiencia Profesional</a>, icon: <DiffOutlined /> },
        {
            key: 'key-7',
            label: (
                <CvGenerator />
            ),
            icon: <FilePdfOutlined />
        },
        /*{ key: 'key-8', label: <a href="#OfertaLaboral">Oferta laboral</a>, icon: <DiffOutlined /> },*/
        {
            key: 'key-logout',
            label: (
                <Button type="link" size="small" onClick={() => logout()}>
                    Cerrar sesión
                </Button>
            ),
            icon: <LogoutOutlined />,
        },
    ];

    return (
        <>
            <Header style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 2rem',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            }}>
                <Image src={ConalepLogo} preview={false} style={{ maxWidth: '150px', width: '15vw' }} alt="Logotipo Conalep" />
                <Menu
                    items={dropdownItems}
                    mode='horizontal'
                    onClick={async ({ key }) => {
                       if (key !== 'key-logout') {
                            onValidateShowWelcome();
                        }
                    }}
                    style={{
                        flex: 1,
                        minWidth: 0,
                        justifyContent: 'flex-end',
                        display: 'flex'
                    }} />
            </Header>
            <div style={{ marginBottom: '3vh' }}></div>
        </>
    );
};

export default HeaderEgresados;
